import { render, staticRenderFns } from "./activity-item.vue?vue&type=template&id=000641cd&scoped=true"
import script from "./activity-item.vue?vue&type=script&lang=js"
export * from "./activity-item.vue?vue&type=script&lang=js"
import style0 from "./activity-item.vue?vue&type=style&index=0&id=000641cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000641cd",
  null
  
)

export default component.exports